import { Box, Button, Divider, H1, H5, HStack, Icon, Paragraph, ScrollView, VStack } from "components/ui";
import SwitchFilter from "components/ui/SwitchFilter";
import { X } from "lucide-react-native";
import React, { useState, useEffect } from "react";
import { SignedIn } from "components/clerk";

type Props = {
	toggleModal: () => void;
	onChange?: (value: any) => void;
	initialFilters?: {
		isCore?: boolean;
		inStock?: boolean;
		isApprovedItem?: boolean;
	};
};

const MobileFilter = (props: Props) => {
	const { toggleModal, onChange, initialFilters = {} } = props;
	const [isCore, setIsCore] = useState(initialFilters.isCore || false);
	const [inStock, setInStock] = useState(initialFilters.inStock || false);
	const [isApprovedItem, setIsApprovedItem] = useState(initialFilters.isApprovedItem || false);
	const [filterState, setFilterState] = useState({
		isCore: initialFilters.isCore || false,
		inStock: initialFilters.inStock || false,
		isApprovedItem: initialFilters.isApprovedItem || false,
	});

	useEffect(() => {
		setIsCore(initialFilters.isCore || false);
		setInStock(initialFilters.inStock || false);
		setIsApprovedItem(initialFilters.isApprovedItem || false);
		setFilterState({
			isCore: initialFilters.isCore || false,
			inStock: initialFilters.inStock || false,
			isApprovedItem: initialFilters.isApprovedItem || false,
		});
	}, [initialFilters]);

	function setFilterValue(key: string, value: any) {
		const newState = {
			...filterState,
			[key]: value,
		};
		setFilterState(newState);
		if (onChange) {
			onChange(newState);
		}
	}

	function clearAllFilters() {
		const newState = {
			isCore: false,
			inStock: false,
			isApprovedItem: false,
		};
		setFilterState(newState);
		setIsCore(false);
		setInStock(false);
		setIsApprovedItem(false);
		if (onChange) {
			onChange(newState);
		}
	}

	return (
		<Box w={"$full"} bg="$basicwhite">
			<Box paddingHorizontal={16}>
				<VStack>
					<SwitchFilter
						text="Is core?"
						toolTip="Priority stock items"
						value={isCore}
						onChange={(value) => {
							setIsCore(value);
							setFilterValue("isCore", value);
						}}
					/>
					<SwitchFilter
						text="In stock?"
						value={inStock}
						onChange={(value) => {
							setInStock(value);
							setFilterValue("inStock", value);
						}}
					/>
					<SignedIn>
						<SwitchFilter
							text="On approved stocklist"
							value={isApprovedItem}
							onChange={(value) => {
								setIsApprovedItem(value);
								setFilterValue("isApprovedItem", value);
							}}
						/>
					</SignedIn>
				</VStack>
				{/* <VStack>
					<SwitchFilter text="In stock?" />
					<SwitchFilter text="On approved stocklist" />
					<SwitchFilter text="Show offers" />
					<SwitchFilter text="Has ESG benefits" defaultValue={true} isLastItem />
				</VStack>
				<VStack paddingVertical={16}>
					<H5>ESG Benefits</H5>
					<Divider bgColor="$neutral100" mt={14} />
					<SwitchFilter text="Is core?" toolTip="This is the core" />
					<SwitchFilter text="In stock?" />
					<SwitchFilter text="On approved stocklist" />
					<SwitchFilter text="Show offers" />
					<SwitchFilter text="Has ESG benefits" defaultValue={true} isLastItem />

					<DropdownFilter title="Recycled content percentage">
						<SwitchFilter text="Show offers" />
						<SwitchFilter text="On approved stocklist" />
						<SwitchFilter text="Show offers" />
						<SwitchFilter text="Has ESG benefits" defaultValue={true} isLastItem />
					</DropdownFilter>
					<H5 sx={{ marginTop: 12 }}>Attributes</H5>
					<DropdownFilter title="Price">
						<SwitchFilter text="Show offers" />
						<SwitchFilter text="On approved stocklist" />
						<SwitchFilter text="Show offers" />
						<SwitchFilter text="Has ESG benefits" defaultValue={true} isLastItem />
					</DropdownFilter>
					<DropdownFilter title="Brand">
						<SwitchFilter text="Show offers" />
						<SwitchFilter text="On approved stocklist" />
						<SwitchFilter text="Show offers" />
						<SwitchFilter text="Has ESG benefits" defaultValue={true} isLastItem />
					</DropdownFilter>
					<DropdownFilter title="Texture">
						<SwitchFilter text="Show offers" />
						<SwitchFilter text="On approved stocklist" />
						<SwitchFilter text="Show offers" />
						<SwitchFilter text="Has ESG benefits" defaultValue={true} isLastItem />
					</DropdownFilter>
				</VStack> */}
			</Box>
		</Box>
	);
};

export default MobileFilter;
